import { makeStyles } from "@mui/styles";

const useStyles = makeStyles((theme) => ({
  container: {
    padding: theme.spacing(4),
    width: "100%",
    height: "100%",
    borderRadius: 8,
    boxShadow:
      "0px 4px 4px rgba(0, 0, 0, 0.05), 0px -4px 4px rgba(0, 0, 0, 0.05), 4px 0px 4px rgba(0, 0, 0, 0.05), -4px 0px 4px rgba(0, 0, 0, 0.05)",
  },
  graphTitle: {
    fontSize: 18,
    fontWeight: 400,
  },
  largeBox: {
    width: "100%",
    height: "100px",
    backgroundColor: theme.palette.background.gray,
    marginBottom: theme.spacing(2),
    borderRadius: 8,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
  },
  scopeBox: {
    width: "80%",
    backgroundColor: theme.palette.background.gray,
    minHeight: "80px",
    borderRadius: 8,
    display: "flex",
    flexDirection: "column",
    justifyContent: "center",
    alignItems: "center",
    padding: theme.spacing(1),
    overflow: "hidden", // hides overflow of large digits
    textAlign: "center",
    wordBreak: "break-word", // wrap long strings
  },

  subTitle: {
    textAlign: "center",
    fontWeight: 600,
    padding: theme.spacing(2, 0),
  },
  subTitleNew: {
    textAlign: "center",
    fontWeight: 600,
    padding: theme.spacing(5, 0),
  },
  value: {
    fontWeight: 400,
    fontSize: "1.4rem",
    maxWidth: "100%",
    textAlign: "center",
    overflowWrap: "break-word",
    wordBreak: "break-word",
    whiteSpace: "nowrap", // prevent excessive line breaking
    overflow: "hidden", // prevent visual spill
    textOverflow: "ellipsis", // show ellipsis if overflow happens
  },

  unit: {
    fontWeight: 400,
    fontSize: 12,
  },
}));

export default useStyles;
